/* import __COLOCATED_TEMPLATE__ from './referrals.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { PRICING_5_1_ADVANCED_SOLUTION_ID } from 'embercom/lib/billing';

interface Args {
  referralCode: string;
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
}

export default class Referrals extends Component<Signature> {
  @service declare intl: any;
  @service declare intercomEventService: any;

  get referralUrl() {
    return `https://app.intercom.com/admins/sign_up?solution_id=${PRICING_5_1_ADVANCED_SOLUTION_ID}&referral_code=${this.args.referralCode}`;
  }

  @action
  showMoreSeatsArticle() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'referral_terms_and_conditions',
      place: 'referrals-page',
      section: 'referrals',
    });
    window.Intercom('showArticle', 8205716); // https://www.intercom.com/help/en/articles/8205716-intercom-seats
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Referrals': typeof Referrals;
    'new-settings/workspace/referrals': typeof Referrals;
  }
}
